import {Button, ButtonProps} from '@mui/material';

import {useIsDownSm} from 'utils/hooks/useMediaQuery';

type PrimaryActionButtonProps = Omit<ButtonProps, 'variant' | 'fullWidth'>;

export const PrimaryActionButton = (props: PrimaryActionButtonProps) => {
  const isDownSm = useIsDownSm();

  return <Button variant='contained' fullWidth={isDownSm} {...props} />;
};
